import "./style.scss";

import * as Yup from "yup";

import { FC, useState } from "react";
import { Form, Formik } from "formik";

import Input from "shared/ui/Input";
import IndicatifPhone from "shared/ui/IndicatifPhone";
import Button from "shared/ui/Button";
import { Button_Style } from "shared/ui/Button/Button";

interface IDAssistantInfoFormProps {
    steps: any;
    setDatas: (data: any) => void;
    datas: any;
    handlePreviousStep: () => void;
    handleNextStep: () => void;
}

const IDPayInfoForm: FC<IDAssistantInfoFormProps> = ({ steps, setDatas, datas, handleNextStep, handlePreviousStep }) => {
    const [phonePrefix, setPhonePrefix] = useState("+33");
    return (
        <div className="IDAssistantInfoForm h-100">
            {
                <Formik
                    initialValues={{
                        firstName: "",
                        lastName: "",
                        email: "",
                        phoneNumber: "",
                    }}
                    validationSchema={Yup.object({
                        firstName: Yup.string()
                            .min(2, "Le prénom doit contenir au moins 2 caractères.")
                            .max(50, "Le prénom ne peut pas dépasser 50 caractères.")
                            .matches(
                            /^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$/,
                            "Seules les lettres, espaces, tirets, apostrophes et accents sont autorisés.",
                            )
                            .required("Le prénom est requis"),
                        lastName: Yup.string()
                            .min(2, "Le nom doit contenir au moins 2 caractères.")
                            .max(20, "Le nom ne peut pas dépasser 20 caractères.")
                            .matches(
                            /^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$/,
                            "Seules les lettres, espaces, tirets, apostrophes et accents sont autorisés.",
                            )
                            .required("Le nom est requis"),
                        email: Yup.string().email("Email invalide").required("L'email est requis"),
                        phoneNumber: Yup.string()
                            .matches(/^([0-9][0-9]{9})$/, "Numéro de téléphone invalide")
                            .required("Le téléphone est requis"),
                    })}
                    onSubmit={(values) => {
                        setDatas({ ...datas, ...values });
                        handleNextStep();
                    }}>
                    {(formik) => (
                        <Form className="w-100 h-100 d-flex flex-column align-items-center justify-content-between">
                            <div>
                                <h3>Vos informations personnelles</h3>
                                <p className="mb-2">Renseignez les coordonnées de la personne dont vous voulez verifier l’identité</p>
                                <Input
                                    onChange={formik.handleChange}
                                    value={formik.values.firstName}
                                    onBlur={formik.handleBlur}
                                    required={true}
                                    placeholder="Prénom"
                                    name="firstName"
                                    type="text"
                                    errorMessage={formik.touched.firstName && formik.errors.firstName ? formik.errors.firstName : ""}
                                />
                                <Input
                                    onChange={formik.handleChange}
                                    value={formik.values.lastName}
                                    onBlur={formik.handleBlur}
                                    required={true}
                                    placeholder="Nom"
                                    name="lastName"
                                    type="text"
                                    errorMessage={formik.touched.lastName && formik.errors.lastName ? formik.errors.lastName : ""}
                                />
                                <Input
                                    required={true}
                                    placeholder="Email"
                                    name="email"
                                    type="email"
                                    onChange={formik.handleChange}
                                    value={formik.values.email}
                                    onBlur={formik.handleBlur}
                                    errorMessage={formik.touched.email && formik.errors.email ? formik.errors.email : ""}
                                />
                                <div className="d-flex gap-1 align-items-end">
                                    <IndicatifPhone
                                        setPhonePrefix={setPhonePrefix}
                                        value={phonePrefix}
                                    />
                                    <Input
                                        placeholder="Numéro de téléphone"
                                        name="phoneNumber"
                                        type="text"
                                        onChange={formik.handleChange}
                                        value={formik.values.phoneNumber}
                                        onBlur={formik.handleBlur}
                                        required={true}
                                        errorMessage={
                                            formik.touched.phoneNumber && formik.errors.phoneNumber ? formik.errors.phoneNumber : ""
                                        }
                                    />
                                </div>
                            </div>

                            <div className={`d-flex justify-content-${!steps[0].isCurrent ? "between" : "end"} w-100`}>
                                <div className='w-100'>
                                    <Button
                                        label={"Retour"}
                                        onClick={() => handlePreviousStep()}
                                        style={Button_Style.OUTLINED}
                                    />
                                </div>

                                <div>
                                    <Button
                                        buttonType={"submit"}
                                        label={"Continuer"}
                                        disabled={!formik.isValid && formik.dirty}
                                    />
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            }
        </div>
    );
};

export default IDPayInfoForm;
